module.exports = __webpack_public_path__ + "static/media/A6v6.150dcd7b.mp3";